import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isUnknownZip } from 'site-modules/shared/utils/location';
import { VisitorEntities, VisitorModel } from 'client/data/models/visitor';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { SrpTopIncentivesContext } from 'site-modules/shared/components/inventory/incentives-wizard/srp-top-incentives/srp-top-incentives-context-provider';
import { RebatesAmount } from './rebates-amount/rebates-amount';

function SrpTopIncentivesTextUI({
  className,
  textColorClassName,
  visitorLocation,
  make,
  model,
  isCrawler,
  isNational,
}) {
  const { totalRebates } = useContext(SrpTopIncentivesContext);
  const isUnknownLocation = isUnknownZip(visitorLocation);

  const showGenericText = isNational || isCrawler || isUnknownLocation;

  return (
    <h2
      className={classnames('mb-0 fw-bold', textColorClassName, className)}
      style={{ lineHeight: '1.5rem', fontSize: '1.25rem' }}
    >
      <div>
        {showGenericText && `Save with ${make} ${model} rebates`}
        {!showGenericText && (
          <>
            <RebatesAmount value={totalRebates} className="ax-gradient" /> {make} {model} rebates in{' '}
            {visitorLocation?.zipCode}
          </>
        )}
      </div>
      <div className="fw-normal" style={{ fontSize: '0.875rem', lineHeight: '1.25rem', marginTop: '4px' }}>
        Check your savings potential before you buy
      </div>
    </h2>
  );
}

SrpTopIncentivesTextUI.propTypes = {
  className: PropTypes.string,
  textColorClassName: PropTypes.string,
  visitorLocation: VisitorEntities.Location,
  make: PropTypes.string,
  model: PropTypes.string,
  isCrawler: PropTypes.bool,
  isNational: PropTypes.bool,
};
SrpTopIncentivesTextUI.defaultProps = {
  className: null,
  textColorClassName: 'text-cool-gray-10',
  visitorLocation: {},
  make: '',
  model: '',
  isCrawler: false,
  isNational: false,
};

export const SrpTopIncentivesText = connectToModel(SrpTopIncentivesTextUI, {
  visitorLocation: bindToPath('location', VisitorModel, null, false),
});
